import { en } from "src/i18n/dictionaries/en";
import { ru } from "src/i18n/dictionaries/ru";
import { Dictionary, Locales } from "src/types/language";

export const LOCALES: Locales[] = ["ru", "en"];
export const defaultLocale: Locales = "ru";

/**
 * As keys are used BCP 47 locale identifiers
 * (see ECMAScript Intl standard)
 */
export const locales: Record<
  Locales,
  { title: string; dictionary: Dictionary }
> = {
  ru: {
    title: "Русский",
    dictionary: ru,
  },
  en: {
    title: "English",
    dictionary: en,
  },
} as const;

export const defaultDictionary = locales[defaultLocale].dictionary;
